export default __webpack_public_path__ + "static/media/2.05614b49.jpg";